import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConsentService, ConsentSource } from 'src/app/services/consent/consent.service';

/**
 * Modal de aceptación del aviso de privacidad y términos de TG Empleos.
 *
 * Patrón:
 *   - Header sticky con título.
 *   - Layer 1: resumen visual de 6 puntos clave.
 *   - Layer 2 (expandible): texto legal completo en scroll.
 *   - Footer sticky con checkbox + botones "Cancelar" / "Acepto y continuar".
 *
 * Uso:
 *   <app-terms-modal *ngIf="show" [source]="'cargar_cv'"
 *                    (accepted)="onAccept()" (cancelled)="show=false">
 *   </app-terms-modal>
 */
@Component({
  selector: 'app-terms-modal',
  templateUrl: './terms-modal.component.html',
  styleUrls: ['./terms-modal.component.scss']
})
export class TermsModalComponent {

  @Input() source: ConsentSource = 'primer_login';
  @Output() accepted = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  showFullText = false;
  acceptedCheckbox = false;
  saving = false;
  errorMsg: string | null = null;

  privacyUrl = '/assets/privacidad.html';
  mapsUrl = 'https://goo.gl/maps/woZXJFvdB5utGTyD8';
  contactEmail = 'contacto@conectify.app';

  constructor(private consent: ConsentService) {}

  toggleFullText(): void {
    this.showFullText = !this.showFullText;
  }

  onAccept(): void {
    if (!this.acceptedCheckbox || this.saving) return;
    this.saving = true;
    this.errorMsg = null;
    this.consent.accept(this.source).subscribe({
      next: () => {
        this.saving = false;
        this.accepted.emit();
      },
      error: err => {
        this.saving = false;
        this.errorMsg = 'No se pudo guardar la aceptación. Revisa tu conexión e inténtalo de nuevo.';
        console.error('[TermsModal] accept failed', err);
      }
    });
  }

  onCancel(): void {
    if (this.saving) return;
    this.cancelled.emit();
  }
}
